/**
 * Converte o path salvo no banco para o segmento da URL da API de imagens,
 * preservando subpastas YYYY-MM-DD.
 *
 * Exemplos:
 * - "infraction_123.jpg" -> "infraction_123.jpg"
 * - "infractions/2026-08-10/infraction_123.jpg" -> "2026-08-10/infraction_123.jpg"
 * - "/mnt/storage/FaceRecognition/infractions/2026-08-10/x.jpg" -> "2026-08-10/x.jpg"
 */
export function toStorageImageApiSegment(imagePath, type) {
  if (!imagePath) return '';

  let normalized = String(imagePath).replace(/\\/g, '/').split('?')[0];
  const typeMarker = `/${type}/`;
  const markerIdx = normalized.toLowerCase().lastIndexOf(typeMarker.toLowerCase());

  if (markerIdx !== -1) {
    normalized = normalized.substring(markerIdx + typeMarker.length);
  } else {
    const typePrefix = `${type}/`;
    if (normalized.toLowerCase().startsWith(typePrefix.toLowerCase())) {
      normalized = normalized.substring(typePrefix.length);
    }
  }

  return normalized
    .split('/')
    .filter(Boolean)
    .map(encodeURIComponent)
    .join('/');
}
